document.addEventListener('DOMContentLoaded', () => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  const toggle = document.querySelector('[data-menu-toggle]');
  if (toggle) {
    const closeMenu = () => {
      document.body.classList.remove('menu-open');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', 'Abrir menú');
    };

    toggle.addEventListener('click', () => {
      const isOpen = document.body.classList.toggle('menu-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      toggle.setAttribute('aria-label', isOpen ? 'Cerrar menú' : 'Abrir menú');
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && document.body.classList.contains('menu-open')) {
        closeMenu();
        toggle.focus();
      }
    });

    document.addEventListener('click', (event) => {
      if (!document.body.classList.contains('menu-open')) return;
      if (event.target.closest('[data-site-header]')) return;
      closeMenu();
    });
  }

  const header = document.querySelector('[data-site-header]');
  if (header) {
    const syncHeader = () => header.classList.toggle('is-scrolled', window.scrollY > 24);
    syncHeader();
    window.addEventListener('scroll', syncHeader, { passive: true });
  }

  const reveals = [...document.querySelectorAll('[data-reveal]')];
  if (reveals.length) {
    if (reduceMotion || !('IntersectionObserver' in window)) {
      reveals.forEach((item) => item.classList.add('is-visible'));
    } else {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
      reveals.forEach((item) => observer.observe(item));
    }
  }

  const techHero = document.querySelector('[data-tech-hero]');
  if (techHero && finePointer && !reduceMotion) {
    techHero.addEventListener('pointermove', (event) => {
      const rect = techHero.getBoundingClientRect();
      const x = ((event.clientX - rect.left) / rect.width) * 100;
      const y = ((event.clientY - rect.top) / rect.height) * 100;
      techHero.style.setProperty('--pointer-x', `${x}%`);
      techHero.style.setProperty('--pointer-y', `${y}%`);
    }, { passive: true });
  }

  if (finePointer && !reduceMotion) {
    document.querySelectorAll('.product-card, .category-tile, .district-collection-card').forEach((card) => {
      card.addEventListener('pointermove', (event) => {
        const rect = card.getBoundingClientRect();
        const x = (event.clientX - rect.left) / rect.width;
        const y = (event.clientY - rect.top) / rect.height;
        card.style.setProperty('--rx', `${(.5 - y) * 5.5}deg`);
        card.style.setProperty('--ry', `${(x - .5) * 5.5}deg`);
      }, { passive: true });
      card.addEventListener('pointerleave', () => {
        card.style.setProperty('--rx', '0deg');
        card.style.setProperty('--ry', '0deg');
      });
    });
  }

  document.querySelectorAll('[data-category-nav]').forEach((navigation) => {
    const activeItem = navigation.querySelector('[aria-current="page"]');
    if (!activeItem || navigation.scrollWidth <= navigation.clientWidth) return;
    const wantedLeft = activeItem.offsetLeft - ((navigation.clientWidth - activeItem.offsetWidth) / 2);
    navigation.scrollTo({ left: Math.max(wantedLeft, 0), behavior: reduceMotion ? 'auto' : 'smooth' });
  });

  const formatOptionLabel = (rawValue) => String(rawValue || '')
    .trim()
    .replace(/\bSliver\b/gi, 'Plateado')
    .replace(/\bSilver\b/gi, 'Plateado')
    .replace(/\bGold\b/gi, 'Dorado')
    .replace(/\bColor\s*Set\s*/gi, '· Set ')
    .replace(/\bColorSet\s*/gi, '· Set ')
    .replace(/(\d+(?:[.,]\d+)?)\s*cm\s+\d+(?:[.,]\d+)?\s*inch(?:es)?/gi, '$1 cm')
    .replace(/(\d+(?:[.,]\d+)?)\s*mm\s*wide/gi, '$1 mm ·')
    .replace(/\s{2,}/g, ' ')
    .replace(/\s+·\s+·/g, ' ·');

  document.querySelectorAll('[data-option-label]').forEach((label) => {
    label.textContent = formatOptionLabel(label.textContent);
  });

  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const json = root.querySelector('[data-variants-json]');
    const form = root.querySelector('[data-product-form]');
    if (!json || !form) return;

    let variants = [];
    try { variants = JSON.parse(json.textContent); } catch (error) { return; }

    const groups = [...root.querySelectorAll('[data-option-group]')];
    const hiddenId = form.querySelector('[data-variant-id]');
    const price = root.querySelector('[data-product-price]');
    const compare = root.querySelector('[data-product-compare]');
    const availability = root.querySelector('[data-product-availability]');
    const visualSelection = root.querySelector('[data-selected-visual]');
    const goldFinishNote = root.querySelector('[data-gold-finish-note]');
    const addButton = form.querySelector('[name="add"]');
    const stage = root.querySelector('[data-gallery-stage]');
    const stageImage = root.querySelector('[data-gallery-main-image]');
    const thumbnails = [...root.querySelectorAll('[data-gallery-thumb]')];
    const studioThumb = root.querySelector('[data-studio-thumb]');
    const currency = root.dataset.currency || 'EUR';

    const money = (cents) => new Intl.NumberFormat(
      document.documentElement.lang || 'es-ES',
      { style: 'currency', currency }
    ).format(Number(cents) / 100);

    const getSelections = () => groups.map((group) => {
      const selected = group.querySelector('.option-chip.is-selected');
      return selected ? selected.dataset.optionValue : '';
    });

    const setActiveThumbnail = (active) => {
      thumbnails.forEach((thumb) => {
        const selected = thumb === active;
        thumb.classList.toggle('is-active', selected);
        thumb.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
    };

    const showGalleryImage = (src, alt, kind, activeThumb) => {
      if (!stageImage || !src) return;
      stageImage.src = src;
      stageImage.alt = alt || '';
      if (stage) {
        const isStudio = kind === 'studio';
        stage.classList.toggle('studio-media', isStudio);
        stage.classList.toggle('is-studio', isStudio);
      }
      if (activeThumb) setActiveThumbnail(activeThumb);
    };

    thumbnails.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        showGalleryImage(
          thumb.dataset.imageSrc,
          thumb.dataset.imageAlt,
          thumb.dataset.imageKind,
          thumb
        );
      });
    });

    const setVariantVisual = (variant) => {
      if (!variant || !variant.studio_asset_url || !studioThumb) return;
      studioThumb.dataset.imageSrc = variant.studio_asset_url;
      studioThumb.dataset.imageAlt = variant.studio_alt || '';
      const thumbImage = studioThumb.querySelector('img');
      if (thumbImage) thumbImage.src = variant.studio_asset_url;
      showGalleryImage(variant.studio_asset_url, variant.studio_alt, 'studio', studioThumb);
    };

    const updateVariant = () => {
      const selections = getSelections();
      const variant = variants.find((item) =>
        item.options && item.options.every((value, index) => value === selections[index])
      );

      if (!variant) {
        if (hiddenId) hiddenId.value = '';
        if (addButton) {
          addButton.disabled = true;
          addButton.textContent = 'Combinación no disponible';
        }
        if (availability) availability.innerHTML = '<span class="availability-dot availability-dot--off"></span>No disponible';
        return;
      }

      if (hiddenId) hiddenId.value = variant.id;
      if (price) price.textContent = money(variant.price);
      if (compare) {
        const validCompare = Number(variant.compare_at_price) > Number(variant.price);
        compare.hidden = !validCompare;
        compare.textContent = validCompare ? money(variant.compare_at_price) : '';
      }
      if (visualSelection) visualSelection.textContent = variant.visual_key || 'Único';
      if (goldFinishNote) goldFinishNote.hidden = !variant.is_gold;
      if (addButton) {
        addButton.disabled = !variant.available;
        addButton.textContent = variant.available ? 'Añadir al carrito' : 'Agotado';
      }
      if (availability) {
        availability.innerHTML = variant.available
          ? '<span class="availability-dot"></span>Disponible'
          : '<span class="availability-dot availability-dot--off"></span>Agotado';
      }

      setVariantVisual(variant);

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };

    groups.forEach((group) => {
      group.querySelectorAll('[data-option-value]').forEach((button) => {
        button.addEventListener('click', () => {
          group.querySelectorAll('[data-option-value]').forEach((item) => {
            item.classList.remove('is-selected');
            item.setAttribute('aria-pressed', 'false');
          });
          button.classList.add('is-selected');
          button.setAttribute('aria-pressed', 'true');
          updateVariant();
        });
      });
    });

    updateVariant();
  });
});

/* AUREO DISTRICT: mejora progresiva del menú sin modificar sus enlaces. */
document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('[data-site-header]');
  const navigation = header?.querySelector('.header-nav');
  const menuToggle = header?.querySelector('[data-menu-toggle]');

  if (!header || !navigation || !menuToggle) return;

  const mobileViewport = window.matchMedia('(max-width: 990px)');
  const groups = [...navigation.querySelectorAll('.nav-item--dropdown')];

  const collapse = (group) => {
    const button = group.querySelector('.district-submenu-toggle');
    if (!button) return;
    group.classList.remove('is-expanded');
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-label', button.dataset.openLabel);
  };

  const collapseAll = (except) => {
    groups.forEach((group) => {
      if (group !== except) collapse(group);
    });
  };

  groups.forEach((group, index) => {
    const parent = group.querySelector('.nav-parent');
    const submenu = group.querySelector('.nav-dropdown');
    if (!parent || !submenu) return;

    const submenuId = submenu.id || `DistrictMobileSubmenu-${index + 1}`;
    submenu.id = submenuId;

    const label = parent.textContent.trim();
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'district-submenu-toggle';
    button.dataset.openLabel = `Mostrar categorías de ${label}`;
    button.dataset.closeLabel = `Ocultar categorías de ${label}`;
    button.setAttribute('aria-label', button.dataset.openLabel);
    button.setAttribute('aria-controls', submenuId);
    button.setAttribute('aria-expanded', 'false');
    button.innerHTML = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="m7 9 5 5 5-5" stroke="currentColor" stroke-width="1.65" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    parent.insertAdjacentElement('afterend', button);

    button.addEventListener('click', () => {
      const isExpanded = group.classList.contains('is-expanded');
      collapseAll(group);
      group.classList.toggle('is-expanded', !isExpanded);
      button.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
      button.setAttribute('aria-label', isExpanded ? button.dataset.openLabel : button.dataset.closeLabel);
    });
  });

  const syncMenuOffset = () => {
    const offset = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
    header.style.setProperty('--district-menu-offset', `${offset}px`);
  };

  menuToggle.addEventListener('click', () => {
    collapseAll();
    syncMenuOffset();
  });

  const handleViewportChange = (event) => {
    collapseAll();
    syncMenuOffset();
    if (!event.matches) {
      document.body.classList.remove('menu-open');
      menuToggle.setAttribute('aria-expanded', 'false');
      menuToggle.setAttribute('aria-label', 'Abrir menú');
    }
  };

  if (typeof mobileViewport.addEventListener === 'function') {
    mobileViewport.addEventListener('change', handleViewportChange);
  } else {
    mobileViewport.addListener(handleViewportChange);
  }

  window.addEventListener('resize', syncMenuOffset, { passive: true });
  window.addEventListener('scroll', syncMenuOffset, { passive: true });
  syncMenuOffset();
});
